import Network from '@/common/lib/Network';
import Store from '@/config/store';

export default {

  getOrderColor(query, order_id) {

    let pnocde = order_id !== undefined ? order_id : null;

    return Network.execute('GET', 'CWEBS0032A', {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      fcol: query,
      pnocde
    });
  },
  getOrderStatus() {
    return Network.execute('GET', 'CWEBS0033A', {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
    });
  },
  getProduct(query, order_id) {

    let pnocde = order_id !== undefined ? order_id : null;

    return Network.execute('GET', 'CWEBS0031A', {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      fmod: query,
      pnocde
    });
  },
  getOrder(oParams) {

    const params = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      ...oParams
    }

    return Network.execute('GET', 'CWEBS0028A', params);
  },
  getRefCustomer(order_id) {

    let pnocde = order_id !== undefined ? order_id : null;

    return Network.execute('GET', 'CWEBS0034A', {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      pnocde
    });    
  },
  getDetailOrder(oParams) {

    const params = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      ...oParams
    };

    return Network.execute('GET', 'CWEBS0029B', params);
  },
  getOrderDetailsInfo(pnocde) {

    const params = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      pnocde
    };

    return Network.execute('GET', 'CWEBS0035A', params);
  },
  getSize(order_id) {

    let pnocde = order_id !== undefined ? order_id : null;

    return Network.execute('GET', 'CWEBS0033A', {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      pnocde
    });
  },
  getDownloadOrderRecipe(order_id) {

    let pncde = order_id !== undefined ? order_id : null;
   
    return Network.execute('GET', 'CWEBS0064A', {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      pncde
    }, {}, {
      'Content-Type': 'application/json',
      'Accept': 'application/pdf'
    }, 'arraybuffer');
  },
  getDownloadOrderConfirm(pncde) {

    return Network.execute('GET', 'CWEBS0063A', {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      pncde
    }, {}, {
      'Content-Type': 'application/json',
      'Accept': 'application/pdf'
    }, 'arraybuffer');
  },
}